import * as actionTypes from './actionTypes'

/**
 * Add an action-to-event mapping
 * @param  {Object} mapping A mapping object
 * @return {action}          A redux action.
 */
export function mapEvents (mapping) {
  return {
    type: actionTypes.MAP_EVENTS,
    payload: mapping
  }
}

/* Interface actions */

/**
 * Add a listener for a specified event type.
 *
 * @param {string} type The event type to add the listener on.
 * @param {Function} listener The event listener to be added.
 * @return {Action} action A redux action.
 */
export function on (type, listener) {
  return {
    type: actionTypes.EVENTS_ON,
    payload: {
      eventType: type,
      listener: listener
    }
  }
}

/**
 * Remove a listener from a specified event type.
 *
 * @param {string} type The event type to remove the listener from.
 * @param {Function} listener The event listener to be removed.
 * @return {Action} action A redux action.
 */
export function off (type, listener) {
  return {
    type: actionTypes.EVENTS_OFF,
    payload: {
      eventType: type,
      listener: listener
    }
  }
}

/**
 * Add a global event listener.
 *
 * @param {Function} listener The event listener to be added.
 * @return {Action} action A redux action.
 */
export function subscribe (listener) {
  return {
    type: actionTypes.EVENTS_SUBSCRIBE,
    payload: listener
  }
}

/**
 * Remove a global event listener.
 *
 * @param {Function} listener The event listener to be removed.
 * @return {Action} action A redux action.
 */
export function unsubscribe (listener) {
  return {
    type: actionTypes.EVENTS_UNSUBSCRIBE,
    payload: listener
  }
}

/* Internal actions */

/**
 * Emits an event of the specified type.
 *
 * @method emitEvent
 * @param {Object} payload Information of the event to emit.
 * @throws {Error} Invalid event type
 * @return action An EVENTS_EMIT action.
 */
export function emitEvent (type, ...args) {
  if (type === undefined) {
    throw Error('Attempted to emit an event without a type.')
  }

  return {
    type: actionTypes.EVENTS_EMIT,
    payload: { eventType: type, args }
  }
}

/**
 * Define an alias for an event type.
 *
 * @method alias
 * @param {string} type The event type for which to add an alias.
 * @param {string} alias The alias name for the event type.
 */
export function aliasEvent (type, alias) {
  if (type === undefined || alias === undefined) {
    throw Error('Invalid attempt to alias an event.')
  }

  return {
    type: actionTypes.EVENTS_ALIAS,
    payload: { eventType: type, alias }
  }
}
